


















import Vue from 'vue';

import { unlinkJiraIssue } from '@/utils/crudActions';
import GenericCard from './GenericCard.vue';

export default Vue.extend({
  name: 'UnlinkJiraConfirmation',
  components: {
    GenericCard,
  },
  props: {
    postUrl: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
  },
  computed: {},
  methods: {
    unlinkJiraIssue,
    async confirmUnlinkIssue() {
      try {
        await this.unlinkJiraIssue({
          csrf: this.csrfToken,
          postUrl: this.postUrl,
        });
        window.GGRC.zenModal.$emit('reloadPage');
        this.$emit('close');
      } catch (error) {
        window.GGRC.Notify({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      }
    },
  },
});
